<div class="d-flex justify-content-around" *ngIf="roles$ | async as roles">
  <nav class="breadCrumbNav ps-3 ps-md-0" [ngStyle]="{ 'border-bottom-color': getUserColor() }" id="breadCrumbNav" *ngIf="breadCrumbStructure && breadCrumbStructure.levels.length > 0">
    <ul>
      <li *ngIf="currentEmployee$ | async as currentEmployee" class="pe-4 ps-4 me-4 employee-greet greetings dropdown" [ngStyle]="{ 'background-color': getUserColor() }" id="roleDrop">
        <button class="dropdown-toggle" type="button" id="dropdownRole" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <span *ngIf="birthdayToday"><i class="fas fa-birthday-cake me-2"></i></span>
          {{ greetingLabel | label : 'header_breadcrumb' | async }}
          {{ currentEmployee.firstName
          }}<span>
            <ng-container *ngIf="hasMultipleRoles(roles) && roleLabel.length"
              ><ng-container *ngIf="hasMultipleRoles(roles)"><span *ngIf="!birthdayToday">, </span><span *ngIf="birthdayToday">! </span></ng-container>
              <ng-container *ngIf="roleLabel == 'Employee' && hasMultipleRoles(roles)">
                <span *ngIf="!birthdayToday">{{ 'greeting_current_role_employee' | label : 'header_breadcrumb' | async }}</span>
                <span *ngIf="birthdayToday">{{ 'greeting_current_role_employee_capitalized' | label : 'header_breadcrumb' | async }}</span>
              </ng-container>
              <ng-container *ngIf="roleLabel != 'Employee'">
                <span *ngIf="!birthdayToday">{{ 'greeting_current_role' | label : 'header_breadcrumb' | async }}</span>
                <span *ngIf="birthdayToday">{{ 'greeting_current_role_capitalized' | label : 'header_breadcrumb' | async }}</span>
                <span *ngIf="roleLabel.length">
                  {{ roleLabel | label : 'header_breadcrumb' | async }}
                </span>
              </ng-container>
              <span *ngIf="isInDelegatedRole()"> - Team {{ isInDelegatedRole().teamName }} </span>
              <ng-container *ngIf="roles.coupledEmployees && roles.coupledEmployees.length > 0"> ({{ currentEmployee.function }}, {{ currentEmployee.department }}) </ng-container>
            </ng-container>
            &nbsp;
          </span>
        </button>
        <div class="dropdown-menu dropdown-menu-left mt-0" style="left: 0px; right: 0px; min-width: 400px" aria-labelledby="dropdownRole">
          <app-role-dropdown></app-role-dropdown>
        </div>
      </li>

      <ng-container *ngFor="let level of breadCrumbStructure.levels; let isFirst = first">
        <li
          app-bread-crumb-navigation-item
          [level]="level"
          [top]="isFirst"
          [noActiveMenuItemFound]="noActiveMenuItemFound"
          [ngClass]="{
            'pe-3': level.menuItems.length < 2 && !(level.activeMenuItem && level.activeMenuItem.isActive)
          }"
          [events]="eventsSubject.asObservable()"
        ></li>
        <li *ngIf="breadCrumbStructure.levels.indexOf(level) < breadCrumbStructure.levels.length - 1">
          <a [ngStyle]="{ color: getUserColor() }">|</a>
        </li>
      </ng-container>
    </ul>
  </nav>
  <ng-container *ngIf="activeMenuItem && activeMenuItem.getAngularUrl() != navigationStructure.getAngularUrl()">
    <ng-container *ngIf="showFavourites">
      <div *ngIf="isFavourite && activeFavourite" [ngStyle]="{ 'border-bottom-color': getUserColor() }" style="width: 175px; border-bottom: 1px solid var(--progreso-accent); padding: 5px 0 4px; background: white">
        <input class="form-control" style="height: 20px; line-height: 20px; font-size: 12px" [ngbTooltip]="'set_favourite_name' | label : 'navigation' | async" container="body" [(ngModel)]="activeFavourite.label" (keyup)="updateMenuFavouriteLabel()" (keydown)="updateMenuFavouriteLabel()" (change)="updateMenuFavouriteLabel()" />
      </div>

      <div class="favourite bg-white" [ngStyle]="{ 'border-bottom-color': getUserColor() }" (click)="removeFavourite()" *ngIf="isFavourite" [ngbTooltip]="'remove_favourite' | label : 'navigation' | async" placement="left" container="body">
        <i class="fas fa-bookmark bookmark"></i>
      </div>
      <div class="favourite bg-white" [ngStyle]="{ 'border-bottom-color': getUserColor() }" (click)="addFavourite()" *ngIf="!isFavourite" [ngbTooltip]="'add_favourite' | label : 'navigation' | async" placement="left" container="body">
        <i class="far fa-bookmark bookmark"></i>
      </div>
    </ng-container>
  </ng-container>
</div>
